module.exports = __webpack_public_path__ + "img/knsu_gallery6.171f333c.jpg";